import axios from 'axios'
import { onMounted } from 'vue'
import { MY_CONSTANTS } from '@/util/constants'
export const useFile = () => {
  let token = ''
  const $imgurl = MY_CONSTANTS.$imgurl
  onMounted(() => {
    const user = localStorage.getItem('user')
    if (user) {
      token = JSON.parse(user).accesstoken
    }
  })

  // 验证文件类型
  const validateFile = (fileName, allowedExtensions) => {
    const ext = fileName.split('.').pop().toLowerCase()
    const validate = allowedExtensions.includes(ext)
    return { validate, ext }
  }

   // 格式化文件大小
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 B'
    const k = 1024
    const sizes = ['B', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  const upload = async (file, url = '/userfile/upload') => {
    const formData = new FormData()
    formData.append('file', file)
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    const res = await axios.post(`${$imgurl}${url}?accesstoken=` + token, formData, config)
    if (res && res.status === 200) {
      return res.data
    }
  }


  return {
    validateFile,
    formatFileSize,
    upload
  }
}